import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';

// Import all components
import AdminDashboard from './pages/AdminDashboard';
import SignUp from './pages/SignUp';
import Login from './pages/Login'; 
import Home from './pages/Home';
import ProductDetail from './pages/ProductDetail';
import Cart from './pages/Cart';
import Footer from './components/Footer'; 
import PrivateRoute from './components/PrivateRoute';
import ForgotPassword from './pages/ForgotPassword'; 

// Import completed pages
import Checkout from './pages/Checkout';
import Profile from './pages/Profile'; 
import ContactUs from './pages/ContactUs'; 
import AboutUs from './pages/AboutUs'; // 💡 NEW: Import the AboutUs page
import OrderSuccess from './pages/OrderSuccess';
import AdminOrders from './pages/AdminOrders';


const App = () => {
    return (
        <>
            <Navbar />
            <main>
                <Routes>
                    {/* PUBLIC ROUTES */}
                    <Route path="/admin" element={<AdminDashboard />} />
                    <Route path="/admin/orders" element={<AdminOrders />} />
                    <Route path="/" element={<Home />} />
                    <Route path="/product/:id" element={<ProductDetail />} />
                    <Route path="/signup" element={<SignUp />} />
                    <Route path="/login" element={<Login />} />
                    <Route path="/forgot-password" element={<ForgotPassword />} />
                    
                    {/* NEW: ABOUT US ROUTE (Public) */}
                    <Route path="/about" element={<AboutUs />} /> 

                    {/* NEW: CONTACT US ROUTE (Public) */}
                    <Route path="/contact" element={<ContactUs />} />

                    {/* ORDER SUCCESS ROUTE (Publicly accessible after payment) */}
                    <Route path="/order-success" element={<OrderSuccess />} />

                    {/* PROTECTED ROUTES */}
                    {/* Note: In a real app, Cart often needs to be public, but we respect your PrivateRoute setup */}
                    <Route path="/cart" element={<PrivateRoute element={Cart} />} />
                    
                    <Route path="/checkout" element={<PrivateRoute element={Checkout} />} /> 
                    
                    {/* Profile Dashboard Route (Protected) */}
                    <Route path="/profile" element={<PrivateRoute element={Profile} />} />
                    
                    {/* Other future protected pages */}
                    <Route path="/wishlist" element={<PrivateRoute element={() => <h1>Wishlist Page (Protected)</h1>} />} />
                </Routes>
            </main>
            <Footer />
        </>
    );
};

export default App;
